// extracted by mini-css-extract-plugin
module.exports = {"spinnerMainContainer":"styles_spinnerMainContainer__9BIki","fixed":"styles_fixed__vqTXJ","static":"styles_static__AiLGn"};